import classNames from "classnames/dedupe";
import React, { FC } from "react";

import { TThemeVariant, useTheme } from "../../Utility/ThemeProvider";

export type IFormLabelNative = JSX.IntrinsicElements["label"];

export interface IFormLabelProps extends IFormLabelNative {
  /**
   * Visual representation of component
   *
   */
  variant?: TThemeVariant;

  /**
   * The custom set of css classes used to style the component
   *
   * root: applied to outer 'div' element
   */
  classes?: { root?: string };
}

const FormLabel: FC<IFormLabelProps> = ({
  id,
  htmlFor,
  classes,
  children,
  variant,
}) => {
  const theme: TThemeVariant = useTheme(variant);

  const labelClasses = classNames("form-check-label", classes?.root, {
    "form-check-label--light": theme === "light",
  });

  return (
    <label htmlFor={htmlFor} id={id} className={labelClasses}>
      {children}
    </label>
  );
};

export default FormLabel;
